import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router'
import { Button, ButtonToolbar, Nav, NavItem, Badge, FormGroup } from 'react-bootstrap'
import DateTimePicker from 'react-widgets/lib/DateTimePicker'
import Spinner from '../common/Spinner'
import List from './../common/List'
import moment from 'moment'
import momentLocalizer from 'react-widgets/lib/localizers/moment'
import style from './styles.less'

class Subscriptions extends Component {
    constructor(props) {
        super(props)
        let self = this
        self.state = {
            dataColumnsNames: [
                'Fecha', 'External Id', 'Email del cliente', 'Producto', 'Monto', 'Acciones'
            ],
            showModal: false,
            loading: false,
            filter: {
                query: {
                    status: 'approved'
                },
                sort: {
                    createdAt: 1
                }
            },
            isFilters: false,
            from: null,
            to: null
        }

        momentLocalizer(moment)
        this.handleSubmit = this.handleSubmit.bind(this)
        self.props.actions.subscriptionPutStatus = self.props.actions.subscriptionPutStatus.bind(self)
        self.props.actions.subscriptionGet = self.props.actions.subscriptionGet.bind(self, self.props.params.appCodename)
        self.props.actions.subscriptionClean = self.props.actions.subscriptionClean.bind(self)
    }

    componentWillMount() {
        let self = this
        let promise = Promise.resolve()

        promise = promise.then(() => {
            var filter = Object.assign({}, self.state.filter)
            var location = self.props.routing && (self.props.routing.location || self.props.routing.locationBeforeTransitions)
            if (location && location.query && location.query.status && (location.query.status === 'approved' || location.query.status === 'pending' || location.query.status === 'rejected')) {
                filter.query = { 'status': location.query.status }
                filter.sort = { createdAt: 1 }
                this.setState({ filter, selectedKey: location.query.status })
            }
            self.setState({ loading: false })
            return Promise.resolve()
        })

        return promise
    }

    componentWillUpdate(nextProps, nextState) {
        let self = this
        if (self.props.location && self.props.location.query && self.props.location.query.status && nextProps[self.props.location.query.status] > self.props[self.props.location.query.status]) {
            self.refreshData(true)
        }
    }

    refreshData(useSkip) {
        let self = this

        if (self.list) {
            let list = self.list.getWrappedInstance()
            return list.refreshData(false)
        }

        return Promise.resolve()
    }

    changeStatus(status) {
        let self = this
        let filter = Object.assign({}, self.state.filter)
        filter.query.status = status
        self.setState({ selectedKey: status, filter })
        self.refreshData(false)
    }

    handleSubmit(event) {
        event.preventDefault()
        let self = this
        let filter = Object.assign({}, self.state.filter)
        let isFilters = true
        if (self.state.from && self.state.to) {
            filter.query.createdAt = { $gte: moment.utc(self.state.from).startOf('day').toISOString(), $lt: moment.utc(self.state.to).add(1, 'day').startOf('day').toISOString() }
        } else if (self.state.from || self.state.to) {
            if (self.state.from) {
                filter.query.createdAt = { $gte: moment.utc(self.state.from).startOf('day').toISOString(), $lt: moment.utc(self.state.from).add(1, 'day').startOf('day').toISOString() }
            } else {
                filter.query.createdAt = { $gte: moment.utc(self.state.to).startOf('day').toISOString(), $lt: moment.utc(self.state.to).add(1, 'day').startOf('day').toISOString() }
            }
        } else {
            isFilters = false
            delete filter.query.createdAt
        }
        self.setState({ filter: filter, isFilters: isFilters })
        self.refreshData(false)
    }

    subscriptionPutStatus(data) {
        let self = this
        self.props.actions.subscriptionPutStatus(self.props.params.appCodename, data).then(function(result) {
            return self.refreshData(true).then(() => {
                self.setState({ loading: false })
            })
        })
    }
    dataObjectProcess(data) {
        let self = this
        let appCodename = self.props.params.appCodename
        let row = []
        var dateTime = new Date(data.createdAt)
        dateTime = moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
        let externalId = (data.externalId) ? data.externalId : '-'
        let emailCustomer = (data.customer && data.customer.internalId && data.customer.internalId.email) ? data.customer.internalId.email : '-'
        let productName = (data.product && data.product.name) ? data.product.name : ''
        let productExternalId = (data.product && data.product.externalId) ? data.product.externalId : ''
        let productAmount = (data.product && data.product.amount) ? '$' + data.product.amount : ''
        let producto
        if (productName !== '') {
            producto = productName + '\n'
        }
        if (productExternalId !== '') {
            producto += productExternalId
        }
        row.push(
            <div>{dateTime}</div>
        )
        row.push(
            <div>{externalId}</div>
        )
        row.push(
            <div className={style.textEmail}>{emailCustomer}</div>
        )
        row.push(
            <div className={style.text}>{producto}</div>
        )
        row.push(
            <div>{productAmount}</div>
        )
        row.push(
            <ButtonToolbar>
                <Link to={`/manager/${appCodename}/subscriptions/detail/${data._id}`} type="button" className="btn btn-sm btn-default">
                    <i className="fa fa-eye" aria-hidden="true"></i>
                </Link>
                <Button onClick={self.subscriptionPutStatus.bind(self, data._id)} type="button" className="btn btn-sm btn-default">
                    <span className="fa fa-ban" aria-hidden="true" ></span>
                </Button>
                <Link to={'/manager/' + self.props.params.appCodename + '/subscriptions/' + data._id + '/transactions'} type='button' className='btn btn-sm btn-primary' disabled={ self.state.loading }>
                    Ver transacciones
                </Link>
            </ButtonToolbar>
        )
        return row
    }

    render() {
        let self = this
        let content
        let itemsProcessed = []

        if (self.props.subscriptions && self.props.subscriptions.length) {
            self.props.subscriptions.forEach(function(user) {
                itemsProcessed.push(self.dataObjectProcess(user))
            })
        }

        let listHeader = (
            <Nav className={style.processNavbar} bsStyle="tabs" activeKey={self.state.selectedKey} onSelect={self.changeStatus.bind(self)}>
                <NavItem key={'approved-' + self.props.approved} eventKey={'approved'} title="approved">Aprobadas <Badge>{self.props.approved}</Badge></NavItem>
                <NavItem key={'pending-' + self.props.pending} eventKey={'pending'} title="pending">Pendientes <Badge>{self.props.pending}</Badge></NavItem>
                <NavItem key={'rejected-' + self.props.rejected} eventKey={'rejected'} title="rejected">Rechazadas <Badge>{self.props.rejected}</Badge></NavItem>
            </Nav>
        )

        let description = false
        if (self.props.profile.profile >= 1000) {
            description = (
                <div>
                    <div className="row">
                        <form className="col-xs-12" onSubmit={this.handleSubmit}>
                            <br/>
                            <div className="row">
                                <div className="col-md-3">
                                    <FormGroup>
                                        <DateTimePicker name="from" culture="es" time={false} placeholder="Desde..." value={self.state.from} max={self.state.to ? new Date(self.state.to) : new Date()} onChange={(value) => { self.setState({ from: value }) }} />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                        <DateTimePicker name="to" culture="es" time={false} placeholder="Hasta..." value={self.state.to} min={self.state.from ? new Date(self.state.from) : undefined} max={new Date()} onChange={(value) => { self.setState({ to: value }) }} />
                                    </FormGroup>
                                </div>
                                <div className="col-md-1">
                                    <Button type="submit" className="pull-right">Filtrar</Button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )
        }

        if (self.state.loading) {
            content = <Spinner />
        } else {
            content = <List ref={(list) => { self.list = list }}
                        items={itemsProcessed}
                        name="Subscripciones"
                        dataColumnsNames={self.state.dataColumnsNames}
                        listHeader={listHeader}
                        description={description}
                        getObjects={self.props.actions.subscriptionGet}
                        clearObjects={self.props.actions.subscriptionClean}
                        params={self.state.filter}
                        limit={50}/>
        }

        return (
            <div>
                {content}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        subscriptions: state.subscriptions,
        profile: state.profile,
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Subscriptions)



// WEBPACK FOOTER //
// ./components/Subscriptions/index.js